<div class="go-link-empty-state-container empty-state">
  <span class="go-link-empty-state-title title">Go links</span>
  <div *ngIf="showDownloadExtension" class="go-link-empty-state-subtitle sub-title" data-cy="go-link-empty-state-subtitle">
    <p>Create intuitive, easy-to-remember, quickly accessible links for</p>
    <p>
      your organization’s most important sites.
      <u-button (onClick)="downloadExtension()" label="Install now" type="link"></u-button>
    </p>
  </div>
  <div *ngIf="!showDownloadExtension" class="go-link-empty-state-subtitle sub-title">
    <p>Create intuitive, easy-to-remember, quickly accessible links for</p>
    <p>your organization’s most important sites.</p>
  </div>
  <u-button
    label="New go link"
    (onClick)="createNewGoLink()"
    data-cy="create-go-link-btn"
    class="create-go-link-btn"
    [typeElement]="'primary'"
    [versionNumber]="2"
  ></u-button>
  <div class="go-link-empty-state-steps">
    <div class="go-link-empty-state-step" *ngFor="let step of GO_LINKS_STEPS; index as index">
      <span class="step-subtitle small-sub-title" [innerHTML]="step.subTitle"></span>
      <u-icon [model]="step.icon" class="step-icon"></u-icon>
    </div>
  </div>
</div>
